import { Theme } from "@workspace/mobile";
import { createPromise, executeNativeFeature } from "@workspace/mobile-core";
import { dmnIdentity } from "../dmnIdentity";
import { dmnStorage } from "../dmnStorage";
import { getEnvironmentProps } from "../environment";

declare global {
  interface Window {
    ReactNativeWebView: any;
  }
}

export const getBuildNumber = async (): Promise<string> => {
  if (!window.ReactNativeWebView) {
    return "Web view";
  }

  const promiseObj = createPromise();
  const promiseId = promiseObj.promiseId;
  const promise: Promise<string | undefined> = promiseObj.promise;
  const request = {
    actionType: "getBuildNumber",
    promiseId: promiseId
  };
  executeNativeFeature(JSON.stringify(request));

  return (await promise) ?? "";
};

export const consoleLog = async (message: string): Promise<void> => {
  if (!window.ReactNativeWebView) {
    console.log(message);
    return;
  }

  const request = {
    actionType: "consoleLog",
    message: message
  };
  executeNativeFeature(JSON.stringify(request));
};

export const forceReload = async (): Promise<void> => {
  if (!window.ReactNativeWebView) {
    history.replaceState({}, "", "/");
    window.location.reload();
    return;
  }

  const request = {
    actionType: "forceReload"
  };
  executeNativeFeature(JSON.stringify(request));
};

export const updateColourScheme = async (
  colourScheme: string
): Promise<void> => {
  if (!window.ReactNativeWebView) {
    dmnStorage.add("theme", colourScheme);
    return;
  }

  const request = {
    actionType: "setColourScheme",
    message: colourScheme.toLowerCase()
  };
  executeNativeFeature(JSON.stringify(request));
};

export const getColourScheme = async (): Promise<Theme> => {
  if (!window.ReactNativeWebView) {
    return (await dmnStorage.get("theme")) ?? "Light";
  }

  const promiseObj = createPromise();
  const promiseId = promiseObj.promiseId;
  const promise: Promise<string | undefined> = promiseObj.promise;
  const request = {
    actionType: "getColourScheme",
    promiseId: promiseId
  };
  executeNativeFeature(JSON.stringify(request));

  const colourScheme = (await promise) ?? "dark";

  return (colourScheme.charAt(0).toUpperCase() +
    colourScheme.slice(1)) as Theme;
};

type EnvironmentName = "Prod" | "PreProd" | "Staging" | "Demo";
export const getEnvironment = async (): Promise<EnvironmentName> => {
  if (!window.ReactNativeWebView) {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);
    return environmentVars.ENVIRONMENT === "Production" ? "Prod" : "PreProd";
  }

  const promiseObj = createPromise();
  const promiseId = promiseObj.promiseId;
  const promise: Promise<EnvironmentName | undefined> = promiseObj.promise;
  const request = {
    actionType: "getEnvironment",
    promiseId: promiseId
  };
  executeNativeFeature(JSON.stringify(request));

  return (await promise) ?? "PreProd";
};
